import { Component, Inject, OnInit, Output, EventEmitter } from '@angular/core';
import {translate} from '@jsverse/transloco';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import cloneDeep from 'lodash/cloneDeep';

@Component({
    selector: 'app-additional-capability',
    templateUrl: './additional-capability.component.html',
    styleUrls: ['./additional-capability.component.scss'],
    standalone: false
})

export class AdditionalCapabilityComponent implements OnInit {
  title: string = translate('DIALOG.CONFIRMATION');
  component: any;
  confirmButtonText: string = translate('DIALOG.CONFIRM');
  selectedCapability: any;
  selection: boolean;
  selectedObj: any;

  constructor(@Inject(MAT_DIALOG_DATA) private data: any, public matdialogRef: MatDialogRef<AdditionalCapabilityComponent>) {
  }

  ngOnInit(): void {

    this.component = cloneDeep(this.data.component);
    this.title = this.data.title || this.title;
    this.confirmButtonText = this.data.confirmButtonText || this.confirmButtonText;
    this.selectedObj = this.component.nestedObj?.filter(item => item.selected);
  }

  selectCapability(capability): void {
    if (!capability.disabled) {
      this.component.nestedObj.find(item => item.name === capability.name).selected = !capability.selected;
      this.selection = false;
      const currentSelectionArr = this.component.nestedObj.filter(item => item.selected);
      currentSelectionArr.forEach(item => {
        if(!(this.selectedObj.find(currentItem => currentItem.name === item.name))) {
          this.selection = true;
        }
      })
      this.selectedObj.forEach(item => {
        if(!(currentSelectionArr.find(currentItem => currentItem.name === item.name))) {
          this.selection = true;
        }
      })
    }
  }

  apply(): void {
  this.matdialogRef.close(this.component);
  }
}


